import React, { useState, useEffect } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import CommonTable from '../components/Common_table'
import SubHeader from '../components/SubHeader'
import { useGlobalContext } from '../../context/Context'
import Adddesign from '../components/Add_design';
import Viewdesign from '../components/View_design'
import instance from '../../Utils/api';
import CircularProgress from '@mui/material/CircularProgress';
import Designstatus from '../components/Design_status'


const 
DesignType = () => {

  const columns = [
    { label: "S.No", field: "sno", },
    { label: "Design Type", field: "designtype", },
    { label: "Banner Image", field: "Bannerimage", },
    { label: "Status", field: "status", },
    { label: "Created Date", field: "createddDate", },
    { label: "Last Updated Date", field: "UpdatedDate", },
    { label: "Actions", field: "action", }
  ];

  const title = { name: "Design Type", subheading: "Add to the design type and view products", search: "Search design type", button: "Add design type" }
  const filterOptions = [
    { label: 'All', value: '' },
    { label: 'Design Type', value: 'design_type' },
    { label: 'Created Date', value: 'createdAt' },
  ];

  //usestate define
  const { loading, setLoading } = useGlobalContext();
  const { openDialog, setOpenDialog } = useGlobalContext();
  const { openviewDialog, setopenviewDialog } = useGlobalContext();
  const [edit, setEdit] = useState(false);
  const [designtype, setDesigntype] = useState([]);
  const [getdesign, setgetdesign] = useState(false);
  const [selectedDesign, setselectedDesign] = useState(null);
  const { statusDialog, setstatusDialog } = useGlobalContext();
  const [totalpages, setTotalPages] = useState();
  const [search, setSearch] = useState();
  const [currentPage, setCurrentPages] = useState(1);
  const [totalCount, setTotalcount] = useState();
  const [selectedFilter, setSelectedFilter] = useState();
  const rowsperpage = 10;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  //fetch designsub
  const fetchDesign = async (search, currentPage, rowsperpage) => {
    const params = {
      search,
      page: currentPage,
      limit: rowsperpage,
      ...(selectedFilter && selectedFilter !== 'None' && { sortBy: selectedFilter }),
      // Exclude 'sortBy' for 'None' or 'All'
    }
    try {
      const response = await instance.get('/Catalogue/getDesignType', { params })
      const formatteddata = response?.data?.data?.map((design, index) => ({
        sno: index + 1,
        category: design?.category,
        subCategory: design?.subCategory,
        designtype: design?.design_type,
        Bannerimage: design?.picture,
        status: design?.status,
        createddDate: new Date(design?.createdAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
        UpdatedDate: new Date(design?.updatedAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
        designId: design?._id,
      }))

      setDesigntype(formatteddata);
      setTotalPages(response?.data?.totalPages);
      setCurrentPages(response?.data?.currentPage);
      setTotalcount(response?.data?.total);
    }
    catch (error) {
      console.log("error to fetch admins:", error.message)
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchDesign(search, currentPage, rowsperpage, selectedFilter)
    setgetdesign(false)
    setLoading(true);
  }, [getdesign, search, currentPage, rowsperpage])

  // Handle Row Click for Edit
  const handleEditClick = (design) => {
    setselectedDesign(design);
    setEdit(true);
    setOpenDialog(true);
  };

  // Handle Row Click for view
  const handleViewClick = (design) => {
    setselectedDesign(design);
    setopenviewDialog(true)
  }

  // Handle Row Click for status change
  const handleStatusClick = (design) => {
    setselectedDesign(design);
    setstatusDialog(true);
  };

  //filter function open menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Apply Filter Handler
  const handleDesigntypeApplyFilter = () => {
    fetchDesign(search, currentPage, rowsperpage, selectedFilter)
    setAnchorEl(null);
  };

  // Menu close handler
  const handleresetFilter = () => {
    setSearch('');
    setSelectedFilter('')
    setCurrentPages(1);
    setgetdesign(true)
    setAnchorEl(null);

  };



  return (
    <>
      <Topbar />
      <section className='admin-catalogue'>
        <PageHeader
          title={title}
          files={false}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          setSearch={setSearch}
        />
        <SubHeader
          menu={false}
          filter={false}
          isVisible={true}
          filterOptions={filterOptions}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          open={open}
          handleClick={handleClick}
          handleDesigntypeApplyFilter={handleDesigntypeApplyFilter}
          handleClearFilter={handleresetFilter}
          isDesigntypepage={true}
        />
        {loading ?
          <div className='loader-section'>
            <CircularProgress />
          </div>
          :
          <CommonTable
            columns={columns}
            rows={designtype}
            edit={edit}
            setEdit={setEdit}
            banner={true}
            menu={true}
            setopenviewDialog={setopenviewDialog}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            handleEditClick={handleEditClick}
            handleViewClick={handleViewClick}
            handleStatusClick={handleStatusClick}
            totalpages={totalpages}
            rowsperpage={rowsperpage}
            totalCount={totalCount}
            currentPage={currentPage}
            setCurrentPages={setCurrentPages}
          />
        }
        <Viewdesign
          openviewDialog={openviewDialog}
          setopenviewDialog={setopenviewDialog}
          mode="Design Type"
          selectedDesign={selectedDesign}
        />
        <Adddesign
          edit={edit}
          setEdit={setEdit}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          selectedDesign={selectedDesign}
          setgetdesign={setgetdesign}
          mode="Design Type"
        />
        <Designstatus
          statusDialog={statusDialog}
          setstatusDialog={setstatusDialog}
          selectedDesign={selectedDesign}
          setgetdesign={setgetdesign}
          mode="Design Type"
        />
      </section>
    </>
  )
}

export default DesignType;
